import { render, staticRenderFns } from "./NewCollisionCheck.vue?vue&type=template&id=23a05d1e&scoped=true"
import script from "./NewCollisionCheck.vue?vue&type=script&lang=js"
export * from "./NewCollisionCheck.vue?vue&type=script&lang=js"
import style0 from "./NewCollisionCheck.vue?vue&type=style&index=0&id=23a05d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a05d1e",
  null
  
)

export default component.exports